module.exports = __webpack_public_path__ + "static/full5-7047fa6a423cb0513d94270aec722f76.png";